import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'components/core/Link';
import { H3, Text } from 'components/core/Typography';
import { PhoneNumber } from 'components/contact/PhoneNumber';
import { FacilityImage } from 'components/facility/FacilityImage';
import { FacilityImageNotAvailable } from 'components/facility/ImageNotAvailable';

import { FacilityReviewSummary } from 'components/search/FacilityCard';

import './facilityImageAndDetails.scss';

export function FacilityImageAndDetails({
	facilityUrl,
	image,
	name,
	location,
	distance,
	withReviews,
	reviewData,
	withStreetAddress,
	formattedPhoneNumber,
	unformattedPhoneNumber,
}) {
	return (
		<div className="facility-image-and-details">
			<Link
				href={facilityUrl}
				className="facility-image-link"
				hideBorder
			>
				{image ? (
					<FacilityImage
						src={image}
						alt={`${name} - ${location.streetAddress}`}
						size="medium"
						className="facility-image"
					/>
				) : (
					<FacilityImageNotAvailable size="large" />
				)}
			</Link>
			<div className="titles">
				<H3 size="tiny">
					<Link
						href={facilityUrl}
						hideBorder
					>
						{name}
					</Link>
				</H3>
				<Text
					size="tiny"
					weight="medium"
					color="gray"
				>
					<div className="location-info">
						{withStreetAddress && !!location && (
							<div>{location.streetAddress}</div>
						)}
						{!!location && (
							<Text
								size="tiny"
								weight="medium"
								color="gray"
							>
								{location.city}, {location.state} {location.zip}
							</Text>
						)}
						{!!distance && (
							<Text className="distance">{`${distance} miles away`}</Text>
						)}
					</div>
				</Text>
				{!!formattedPhoneNumber && (
					<PhoneNumber
						hideIcon
						hideBorder
						clickable
						color="light"
						strong={false}
						size="tiny"
						phoneNumber={formattedPhoneNumber}
						unformattedPhoneNumber={unformattedPhoneNumber}
					/>
				)}
				{withReviews && !!reviewData && (
					<FacilityReviewSummary
						rating={reviewData.average}
						reviewCount={reviewData.count}
						facilityUrl={facilityUrl}
						starSize="tiny"
					/>
				)}
			</div>
		</div>
	);
}

FacilityImageAndDetails.propTypes = {
	facilityUrl: PropTypes.string.isRequired,
	image: PropTypes.string,
	name: PropTypes.string.isRequired,
	location: PropTypes.object,
	distance: PropTypes.number,
	withReviews: PropTypes.bool,
	reviewData: PropTypes.object,
	withStreetAddress: PropTypes.bool,
	formattedPhoneNumber: PropTypes.string,
	unformattedPhoneNumber: PropTypes.string,
};

export default FacilityImageAndDetails;
